<style lang="scss">
  @import '../resources/scss/project_circle.scss';
</style>

<script lang="ts">
  import type MenuIcon from '../api/rest/directus-cms/menus/model/MenuIcon'

  export let image: MenuIcon
</script>

<div class="position-relative">
  <div class="position-absolute banner-circle">
    <img class="circle-image" src={image.fullUrl} alt="circle" />
  </div>
</div>
